import {TagTypesEnum} from '../../../../libs/shared/core/src/models/api/commonTagModel';
import {PaletteColorsEnum} from '../../../../libs/shared/core/src/models/api/paletteModel';
import {HighlightTypesEnum} from '../../../models/api/highlightBaseModel';
import {TagModel} from '../../../models/api/tagModel';

export interface TagTemplate {
  name: string;
  description?: string;
  namespace: string;
  parentTags: ReadonlyArray<TagModel>;
  highlightType: HighlightTypesEnum;
  type?: TagTypesEnum;
  highlightEmoji?: string;
  highlightColor?: PaletteColorsEnum;
  showInWorkspaces?: boolean;
  showInCells?: boolean;
  teammatesToPin?: ReadonlyArray<number>;
  isVisibleInAllInboxes?: boolean;
  inboxIds?: ReadonlyArray<number>;
  isSlaAppliesTag?: boolean;
}

// Note: this is primarily used for optimistic updates.
export function mergeTagWithTagTemplate(tag: TagModel, tagTemplate: TagTemplate): TagModel {
  const baseTag = {
    ...tag,
    name: tagTemplate.name,
    description: tagTemplate.description,
    namespace: tagTemplate.namespace,
    parentTagId: tagTemplate.parentTags[0] ? tagTemplate.parentTags[0].id : tag.parentTagId,
    showInCells: tagTemplate.showInCells,
    isVisibleInAllInboxes: tagTemplate.isVisibleInAllInboxes ?? tag.isVisibleInAllInboxes,
    inboxIds: tagTemplate.inboxIds ?? tag.inboxIds,
  };

  if (tagTemplate.highlightType === HighlightTypesEnum.EMOJI && tagTemplate.highlightEmoji) {
    return {
      ...baseTag,
      type: HighlightTypesEnum.EMOJI,
      // This shouldn't be undefined, but we fall back to '' in case it is.
      highlightEmoji: tagTemplate.highlightEmoji ?? '',
    };
  }

  if (tagTemplate.highlightType === HighlightTypesEnum.COLOR && tagTemplate.highlightColor) {
    return {
      ...baseTag,
      type: HighlightTypesEnum.COLOR,
      // This shouldn't be undefined, but we fall back to GREY in case it is.
      highlightColor: tagTemplate.highlightColor ?? PaletteColorsEnum.GREY,
    };
  }

  return baseTag;
}

export function serializeTagTemplate(tagTemplate: TagTemplate) {
  let highlight;
  if (tagTemplate.highlightType === HighlightTypesEnum.EMOJI && tagTemplate.highlightEmoji) {
    highlight = tagTemplate.highlightEmoji;
  } else if (tagTemplate.highlightType === HighlightTypesEnum.COLOR && tagTemplate.highlightColor) {
    highlight = tagTemplate.highlightColor.toString();
  }

  return {
    name: tagTemplate.name,
    description: tagTemplate.description,
    namespace: tagTemplate.namespace,
    parent_tag_id: tagTemplate.parentTags[0]?.id || null,
    highlight,
    is_visible_in_p2: tagTemplate.showInCells,
    all_inboxes: tagTemplate.isVisibleInAllInboxes,
    inbox_ids: tagTemplate.inboxIds,
    is_sla_applies_tag: tagTemplate.isSlaAppliesTag,
    type: tagTemplate.type,
  };
}
